import { motion } from "framer-motion";
import { Clock3, Wallet, TrendingUp } from "lucide-react";

const rows = [
  {
    metric: "-14 h",
    label: "por semana en captura",
    detail: "Un empleado promedio pierde 2 horas diarias tecleando ventas e inventario. Con CHALANN, cero.",
    icon: Clock3,
    color: "#ccff00",
  },
  {
    metric: "+$4,200",
    label: "MXN al mes tan sólo por evitar errores en las cuentas y mejor manejo de inventarios",
    detail: "Menos filas = más clientes atendidos por hora. Más margen porque los errores de captura dejan de comerte la ganancia.",
    icon: Wallet,
    color: "#ff5a00",
  },
  {
    metric: "0",
    label: "errores de tecleo",
    detail: "Cuando cobras hablando, no confundes precios ni cantidades. El corte de caja siempre cuadra.",
    icon: TrendingUp,
    color: "#f5f5f5",
  },
];

export default function Savings() {
  return (
    <section
      id="precio"
      className="relative py-24 md:py-32 bg-[#080808]"
      data-testid="savings"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-3">
            <p className="font-mono text-[11px] tracking-[0.3em] text-white/40 uppercase">
              / El ahorro
            </p>
          </div>
          <div className="md:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1 }}
              className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95]"
            >
              Cada segundo detrás <br className="hidden md:block" />
              del mostrador <span className="text-[#ff5a00]">cuesta dinero.</span>
            </motion.h2>
            <p className="mt-6 text-white/60 max-w-xl text-[15px] leading-relaxed">
              CHALANN es el único punto de venta pensado para tiendas mexicanas donde el tiempo del tendero vale más que la tecnología. Menos apps, más ventas.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {rows.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                className="rounded-2xl border border-white/10 bg-white/[0.02] p-8 md:p-10 relative overflow-hidden"
                data-testid={`saving-${i}`}
              >
                <div className="flex items-start justify-between mb-8">
                  <Icon size={28} strokeWidth={1.5} style={{ color: r.color }} />
                  <span className="font-mono text-[10px] tracking-widest text-white/40 uppercase">
                    0{i + 1} · INDICADOR DE AHORRO
                  </span>
                </div>
                <p className="font-display text-6xl md:text-7xl tracking-tighter leading-none" style={{ color: r.color }}>
                  {r.metric}
                </p>
                <p className="mt-3 text-white/80 text-sm">{r.label}</p>
                <p className="mt-6 pt-6 border-t border-white/10 text-white/60 text-[13px] leading-relaxed">
                  {r.detail}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
